export default __webpack_public_path__ + "static/media/imdb.1fd6c3b4.png";